import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../utils/common'
import Button from '../../../Button'
import { getEmptyStateActions, PageEmptyState } from '../../../PageEmptyState'
import {
  QA_NAME_ADD_CHECKLIST_BUTTON,
  QA_NAME_REQUEST_PROFILE_TAB_INTERNAL_TASKS,
} from '../RequestProfileTabInternalTasks.constants'
import { useRequestProfileTabInternalTasksContext } from '../RequestProfileTabInternalTasks.hooks'
import { RequestProfileTabInternalTasksChecklist } from '../RequestProfileTabInternalTasksChecklist'
import { RequestProfileTabInternalTasksCreateModal } from '../RequestProfileTabInternalTasksCreateModal'
import { RequestProfileTabInternalTasksSkeleton } from '../RequestProfileTabInternalTasksSkeleton'

import * as styles from './RequestProfileTabInternalTasksContent.module.css'

import PlusIcon from '../../../../icons/plus.svg'
import TaskIcon from '../../../../icons/task.svg'

function RequestProfileTabInternalTasksContent() {
  const { t } = useTranslation()

  const {
    canEdit,
    checklists,
    handleCreateChecklist,
    hasError,
    isLoading,
    setModal,
    onCloseModal,
  } = useRequestProfileTabInternalTasksContext()

  function handleOpenCreateModal() {
    setModal(
      <RequestProfileTabInternalTasksCreateModal
        onClose={onCloseModal}
        onCreate={handleCreateChecklist}
      />
    )
  }

  return isLoading ? (
    <RequestProfileTabInternalTasksSkeleton />
  ) : hasError ? (
    <PageEmptyState
      className={styles.emptyState}
      text={t('Error.CommonApiRequestFailKey')}
    />
  ) : checklists.length === 0 ? (
    <PageEmptyState
      EntityIcon={TaskIcon}
      actions={getEmptyStateActions({
        actionName: QA_NAME_ADD_CHECKLIST_BUTTON,
        qaName: QA_NAME_ADD_CHECKLIST_BUTTON,
        shouldShowActions: canEdit,
        text: t('RequestProfile.InternalTasksAddListKey'),
        onClick: handleOpenCreateModal,
      })}
      className={styles.emptyState}
      text={t('RequestProfile.InternalTasksNoTasksKey')}
    />
  ) : (
    <div
      {...getQaSelector({ value: QA_NAME_REQUEST_PROFILE_TAB_INTERNAL_TASKS })}
      className={styles.RequestProfileTabInternalTasksContent}
    >
      {canEdit ? (
        <div className={styles.topActions}>
          <Button.Text
            beforeIconProps={{ Icon: PlusIcon }}
            qaName={QA_NAME_ADD_CHECKLIST_BUTTON}
            text={t('RequestProfile.InternalTasksAddListKey')}
            onClick={handleOpenCreateModal}
          />
        </div>
      ) : null}
      <div className={styles.list}>
        {checklists.map(checklist => (
          <RequestProfileTabInternalTasksChecklist
            checklist={checklist}
            key={checklist.id}
          />
        ))}
      </div>
      {canEdit ? (
        <Button.Contained
          isLight
          beforeIconProps={{ Icon: PlusIcon }}
          className={styles.bottomAction}
          qaName={QA_NAME_ADD_CHECKLIST_BUTTON}
          text={t('RequestProfile.InternalTasksAddListKey')}
          onClick={handleOpenCreateModal}
        />
      ) : null}
    </div>
  )
}

export default RequestProfileTabInternalTasksContent
